import { render, staticRenderFns } from "./InputTextResizable.vue?vue&type=template&id=34c81ddc&"
import script from "./InputTextResizable.vue?vue&type=script&lang=js&"
export * from "./InputTextResizable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports